import { ComponentProps, FC } from 'react';
import { differenceInHours } from 'date-fns';

import { Axis } from '@visx/axis';
import { timeFormat } from '@visx/vendor/d3-time-format';

import useMwdTimescale from '../../state/selectors/useMwdTimescale';

import styles from './TimeScale.module.css';

const TickHours: FC<Partial<ComponentProps<typeof Axis>> & { mini?: boolean }> = ({
  mini = false,
  ...overwriteAxisProps
}) => {
  const { start, end, scale } = useMwdTimescale(mini ? 'miniMwd' : 'mwd');
  return (
    <Axis
      orientation='top'
      scale={scale}
      left={0}
      numTicks={differenceInHours(end, start)}
      hideTicks
      stroke='var(--tractie-color-border-emphasis)'
      tickStroke='var(--tractie-color-border-emphasis)'
      tickClassName={mini ? styles.miniTickHoursStyle : styles.tickHoursStyle}
      strokeWidth={0.71}
      tickFormat={(v: Date, _: number) => {
        return timeFormat('%H:%M')(v);
      }}
      {...overwriteAxisProps}
    />
  );
};
export default TickHours;
